import React from "react";
import { CommonActorDetailHeader } from "./commonActorDetailHeader";
import { useSelector } from "react-redux";

export  const ActorDetailHeader = ({tableName,...rest}) => {
    const actorName=useSelector(state=>state.actorReducer[tableName][0]?.name)
    return (
      <CommonActorDetailHeader name={actorName} {...rest} />
     );
  
}


export default React.memo(ActorDetailHeader)
